/* --------------------------------------------------
                Imports
-------------------------------------------------- */
import { Controller } from "@hotwired/stimulus"

/* --------------------------------------------------
                Stimulus Modal Controller
-------------------------------------------------- */
export default class extends Controller {
  static targets = [ "background" ]

  connect() {
    if (!!this.data.get("param") && !!this.data.get("paramId")) {
      const newLocation = `${window.location.pathname}?${this.data.get("param")}=${this.data.get("paramId")}`
      history.pushState({ urlPath: newLocation }, "", newLocation)
    }
  }

  show(event) {
    // If triggered by an event, ensure it originated from within this modal
    // This prevents the modal from opening when Turbo preloads other frames
    if (event && event.target && !this.element.contains(event.target)) {
      return
    }

    this.element.classList.remove("hidden")
    this.element.setAttribute("aria-hidden", "false")
    document.body.style.overflow = "hidden"
  }

  close() {
    this.element.classList.add("hidden")
    this.element.setAttribute("aria-hidden", "true")
    document.body.style.overflow = "auto"
  }

  closeBackground(e) {
    if (e.target === this.backgroundTarget) {
      this.close(e)
    }
  }

  handleKeyup(e) {
    if (e.code == "Escape") {
      this.close()
    }
  }
}
